import React from 'react';
import Tooltip from '../../../components/Tooltip';
import classNames from 'classnames';

export default function IconSection(props) {
  const { title, subtitle, icon, tooltip, color = 'text-cs-gray-500' } = props;

  return (
    <div className="flex items-center space-x-1">
      {tooltip ? (
        <Tooltip tooltip={tooltip} icon={false}>
          <props.icon className={classNames(
            color,
            'h-6 w-6'
          )}/>
        </Tooltip>
      ) : (
        <props.icon className={classNames(
            color,
            'h-6 w-6'
          )}/>
      )}
      {/*<div className="flex">*/}
        <div className={classNames(
          'flex-1 text-sm',
          color
        )}>
          {title}
        </div>
        {/*{subtitle && (*/}
        {/*  <div className={xs ? 'text-xs text-cs-gray-400' : 'text-sm text-cs-gray-500'}>*/}
        {/*    {subtitle}*/}
        {/*  </div>*/}
        {/*)}*/}
      {/*</div>*/}
    </div>
  );
}
